import React from "react"
import { useGetOperatorsQuery } from "../../features/operator-report/service.ts"

interface OperatorFilterProps {
  operatorId: number
  onOperatorChange: (operatorId: string) => void
  departmentId: number
}

export const OperatorFilter: React.FC<OperatorFilterProps> = ({ operatorId, onOperatorChange, departmentId }) => {
  const { data: operators } = useGetOperatorsQuery({
    departmentId,
  })

  return (
    <div className="form-control flex-1 max-w-xs">
      <label htmlFor="operator" className="label">
        <span className="label-text">Оператор</span>
      </label>
      <select
        id="operator"
        name="operator"
        className="select select-bordered"
        value={operatorId || ""}
        onChange={e => onOperatorChange(e.target.value)}
      >
        <option value="">Все</option>
        {operators?.map(operator => (
          <option key={operator.id} value={operator.id}>
            {operator.name}
          </option>
        ))}
      </select>
    </div>
  )
}
